import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { CloudUpload } from "lucide-react";

export function DriveSyncPanel() {
  const [busy, setBusy] = useState(false);
  const sync = async () => {
    setBusy(true);
    try { await api.post("/drive/sync-availability"); toast.success("File su Google Drive aggiornato"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="flex justify-end" data-testid="drive-sync-panel">
        <Button size="sm" data-testid="drive-sync-btn" disabled={busy} onClick={sync} className="bg-emerald-500 hover:bg-emerald-600 text-slate-950 font-semibold">
          <CloudUpload className="w-4 h-4 mr-1.5" /> {busy ? "Aggiorno…" : "Aggiorna su Drive"}
        </Button>
    </div>
  );
}
